const METHODS = ['get', 'post', 'put', 'patch', 'delete', 'head', 'options', 'trace'];
export function filterReferenceSpec(source, filter = 'all') {
  if (!source?.['x-prime-reference']) throw new Error('Backend API Reference belum mendukung scope PRIME. Deploy pembaruan backend dan frontend bersama.');
  const doc = JSON.parse(JSON.stringify(source));
  const tags = new Map();
  let operations = 0;
  for (const [path, item] of Object.entries(doc.paths || {})) {
    for (const method of METHODS) {
      if (!item[method]) continue;
      const c = item[method]['x-prime-classification'];
      const matches = filter === 'all' || c?.owner === filter
        || filter === 'business' && c?.owner === 'PRIME' && !['restricted', 'system'].includes(c?.audience)
        || filter === 'eligible' && c?.gatewayEligible === true
        || filter === 'restricted' && ['restricted', 'system'].includes(c?.audience);
      if (c?.referenceScope !== 'prime' || !matches) { delete item[method]; continue; }
      operations++;
      for (const name of item[method].tags || []) tags.set(name, (tags.get(name) || 0) + 1);
    }
    if (!METHODS.some(method => item[method])) delete doc.paths[path];
  }
  const definitions = new Map((source.tags || []).map(tag => [tag.name, tag]));
  doc.tags = [...tags].map(([name, count]) => ({ ...definitions.get(name), name, description: `${count} operation${count === 1 ? '' : 's'}` }));
  delete doc['x-tagGroups'];
  doc['x-prime-reference'] = { ...doc['x-prime-reference'], filter, visibleOperations: operations, visibleGroups: tags.size };
  return doc;
}
